var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          style: { zIndex: _vm.zIndex },
          attrs: {
            attach: "body",
            "max-width": _vm.infoMaxWidth,
            persistent: _vm.persistent
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "box",
            {
              attrs: {
                closable: "",
                fillHeight: true,
                resizable: _vm.resizable,
                background: "white"
              },
              on: { closed: _vm.onOk },
              model: {
                value: _vm.show,
                callback: function($$v) {
                  _vm.show = $$v
                },
                expression: "show"
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h3", [_vm._v(_vm._s(_vm.infoTitle))])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _c("div", { domProps: { innerHTML: _vm._s(_vm.infoText) } })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-right",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.onOk($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.infoOk))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-662da4f6", { render: render, staticRenderFns: staticRenderFns })
  }
}